<template>
    <div id="top-bar">
        <img class="logo-dr100" src="../../images/logo-dr100.png" @click="goToIndex">
        <div class="main-heading"><p class="heading-wrapper">Umów wizytę w <b>{{ $store.facility.name }}</b></p></div>
        <div class="extra-heading" v-if="extraHeading">
            <i class="mi mi-arrow-back btn-back" @click="$router.back()"></i>{{ extraHeading }}
        </div>
        <div class="credentials" v-else-if="$store.isPatientLoggedIn">
            <div class="patient-info">{{ $store.patient.name }} {{ $store.patient.surname }}</div>
            <button class="btn-default btn-outline-blue btn-logout" @click="logout">WYLOGUJ SIĘ</button>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import "../../css/colors.scss";

#top-bar {
    display: flex;
    flex-flow: row;
    align-items: center;
    background: $blue;
    color: white;
    min-height: 100px;

    .logo-dr100 {
        flex-shrink: 0;
        max-height: 67px;
        margin-left: 1em;
        cursor: pointer;
    }
    .main-heading {
        font-size: 1.7em;
        padding-left: 1em;
        margin-right: auto;
        max-width: 600px;

        .heading-wrapper {
            margin: 0;
            padding-bottom: 0.3em;
            padding-top: 0.3em;
        }
    }
    .credentials {
        text-align: center;
        padding-left: 1em;
        padding-right: 1.5em;
        margin-left: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-bottom: 0.3em;

        .patient-info {
            font-weight: bold;
        }
        .btn-logout {
            min-width: 130px;
        }
    }
    .extra-heading {
        font-weight: bold;
        font-size: 28px;
        padding-left: 1em;
        padding-right: 1em;
        display: flex;
        align-items: center;

        .btn-back {
            font-weight: 600;
        }
    }
    @media all and (max-width: 650px) {
        flex-wrap: wrap;

        .credentials {
            flex-direction: row;

            .patient-info {
                margin-right: 0.8em;
            }
        }
        .extra-heading {
            padding-left: 0.8em;
            padding-bottom: 0.3em;
        }
    }
}
</style>

<script>
import ApiMixin from '../mixins/ApiMixin.js'

export default {
    name: 'TopBar',
    mixins: [
        ApiMixin,
    ],
    data() {
        return {
            extraHeading: '',
        }
    },
    methods: {
        goToIndex() {
            this.$router.push({name: 'index'});
        },
        logout() {
            this.$http.post(this.$api.logout()).then(() => {
                this.$bus.$emit('$store:setIsPatientLoggedIn', false);
                this.$app.showSuccessAlert('Zostałeś pomyślnie wylogowany.');
                this.$router.push({name: 'index'});
            });
        },
    },
    mounted() {
        this.$bus.$on('TopBar:setExtraHeading', value => {
            this.extraHeading = value;
        });
    },
}
</script>



// WEBPACK FOOTER //
// TopBar.vue?73672c72